import { useNavigate, useParams } from "react-router-dom";
import ServerRequest from "../../exports/ServerRequest";
import { useEffect, useState } from "react";
import Pulse from "../Loader/Pulse";
import CustomIconButton from "../Body/CustomChartComponents/CustomIconButton/CustomIconButton";
import { ArrowRight2 } from "../CustomComponents/SwiftIcon/Icons";
import { decodeToken, priceFormat } from "../../exports/UtilFunctions";
import CustomInputFile from "../CustomComponents/CustomInputFile/CustomInputFile";
import { COLOR_VARS } from "../../exports/ColorVars";
import { Alert } from "../Body/CustomChartComponents/CustomAlert/CustomAlert.js";
import CustomDatePicker from "../CustomComponents/CustomInputDate/CustomDatePicker.js";

const warning_config = {
    Band: true,
    BandColor: "var(--main-blue)",
    BoxColor: "var(--white)",
    TextColor: "var(--text-color)",
    AutoClose: {
        Active: true,
        Line: true,
        LineColor: "var(--main-blue)",
        Time: 3,
    },
};

export default function UTRSubmitPage() {
    const { orderId } = useParams();

    const data = decodeToken(orderId)

    const [orders, setOrders] = useState([]);
    const [utr, setUtr] = useState(null);
    const [date, setDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingMsg, setLoadingMsg] = useState("Loading your page");
    const [opacityMsg, setOpacityMsg] = useState(true);
    const [confirm, setConfirm] = useState(false)

    console.log(orders)

    useEffect(() => {
        getOrdersByInternalNo();

        const loadingMessageInterval = setInterval(() => {
            setLoadingMsg(prev =>
                prev === "Loading your page"
                    ? "It may take some time"
                    : "Loading your page"
            );
        }, 3000);

        const opacityInterval = setInterval(() => {
            setOpacityMsg(prev => !prev);
        }, 1500);

        // Cleanup
        return () => {
            clearInterval(loadingMessageInterval);
            clearInterval(opacityInterval);
        };
    }, [orderId]);

    const getOrdersByInternalNo = async () => {
        try {
            setLoading(true);
            const response = await ServerRequest({
                url: `/mf/fetchorderbyinternalreferenceno?internal_no=${data.internal_id}`,
                method: "get",
                withCredentials: false, 
            });

            console.log(response.data)
            setOrders(response.data || []);
        } catch (error) {
            console.error("Failed to fetch orders", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitUTR = async () => {
        try {
            if (utr === null || utr === "") {
                Alert({
                    TitleText: "Warning",
                    Message: "Please enter UTR No.",
                    ...warning_config,
                });
            } else {
                const response = await ServerRequest({
                    url: `/nse/post-utr`,
                    method: "post",
                    data: {
                        utr_number: utr,
                        orders: orders,
                        transfer_date: date,
                        data: data
                    },
                });
                if (response.success === true) {
                    setConfirm(true)
                }
            }

        } catch (error) {
            console.error("Error submitting UTR", error);
            alert("Failed to submit UTR ❌");
        }
    };

    return (
        <div className="utr_container">
            {loading ? (
                <div className="app__login__screen">
                    <div className="app__login__process">
                        <Pulse />
                        {/* <p className={opacityMsg ? 'fadeIn' : 'fadeOut'}>{loadingMsg}</p> */}
                    </div>
                </div>
            ) : (
                <div className="swift-mf-popup">

                    <>
                        <div>
                            <div className="swift-mf-popup-header">
                                <div className={`swift-mf-popup-header-title`}>
                                    Input Bank Transfer Reference
                                    {!confirm ? <> <div className="swift-mf-popup-text">
                                        We will confirm the success or failure of the transaction shortly.
                                    </div></> : <>
                                        <div className="swift-mf-popup-text">
                                            You have successfully submitted UTR. You may close down this tab.
                                        </div>
                                    </>}
                                </div>

                            </div>

                            <div className="swift-mf-popup-body">
                                <div className="swift-mf-popup-details">
                                    {orders?.map((order) => (
                                        <div className="popup-card" key={order.transaction_ref_number}>
                                            <p className="swift-mf-popup-isin">{order.transaction_ref_number}</p>
                                            <p className="swift-mf-popup-name">{order.fund_name}</p>
                                            <p className="swift-mf-popup-isin">{priceFormat(order.amount)}</p>
                                        </div>
                                    ))}
                                </div>

                                {!confirm ? <>
                                    <CustomInputFile
                                        name="utr_number"
                                        type="text"
                                        value={utr}
                                        className="swift-mf-bonds-inputs"
                                        DivClassName="swift-mf-bonds-inputs-div"
                                        placeholder="UTR Number"
                                        onchange={(name, value) => setUtr(value)}
                                    />
                                    <p className="swift-mf-popup-isin">Transaction Date</p>
                                    <CustomDatePicker
                                        name="transaction_date"
                                        value={date}
                                        placeholder="Transaction Date"
                                       onchange={(name, value) => setDate(value)}
                                    />


                                </> : <>

                                </>}
                            </div>
                        </div>
                        <div className="swift-mf-popup-submit-btn">
                            {!confirm ?
                                <CustomIconButton
                                    title="Submit"
                                    icon={
                                        {/* <ArrowRight2 size={20} color={COLOR_VARS.SWIFT_COLOR1} /> */}
                                    }
                                    onClick={handleSubmitUTR}
                                /> : ""}
                        </div>
                    </>
                </div>
            )}
        </div>
    );
}
